export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20overhead%20flatlay%20composition%20featuring%20assorted%20fashion%20and%20lifestyle%20products%20including%20designer%20sunglasses%20a%20leather%20crossbody%20bag%20rolled%20linen%20scarves%20and%20gold%20tone%20jewelry%20pieces%20arranged%20artfully%20on%20textured%20blush%20pink%20linen%20fabric%20with%20scattered%20eucalyptus%20leaves%20and%20dried%20flowers%20natural%20morning%20sunlight%20casting%20soft%20diagonal%20shadows%20sophisticated%20editorial%20aesthetic%20with%20warm%20rosy%20tones%20and%20organic%20textures&width=1800&height=1000&seq=hero-bg-kakobuy-v2&orientation=landscape"
        alt="Kakobuy Spreadsheet Polska - moda i akcesoria"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6">
          Kakobuy Spreadsheet Polska
        </h1>
        <p className="text-base md:text-xl text-white/80 max-w-2xl mx-auto mb-5 md:mb-8 leading-relaxed">
          Najlepszy przewodnik zakupów z Chin. Znajduj najlepsze produkty z Taobao, Weidian i 1688 szybciej dzięki sprawdzonym listom produktów Kakobuy Spreadsheet.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            Kakobuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white font-semibold text-sm rounded-full border border-white/25 hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-8 md:mt-10">
          {['Aktualne informacje', 'Poradniki dla początkujących', 'Porównania produktów', 'Bezpieczne zakupy'].map((badge) => (
            <span key={badge} className="flex items-center gap-1.5 text-white/70 text-xs md:text-sm">
              <i className="ri-check-line text-primary-400 text-sm"></i>
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}